export enum ShippingMethod {
  CustomCarrier = 0,
  CorreiosPAC = 1,
  CorreiosSedex = 2,
  FreeShipping = 3,
  StorePickup = 4
};
